import React from 'react';
import './index.scss';
import classNames from 'classnames';
import { IHighLightTextProps } from './type';

/**
 * 高亮文本组件
 * 根据关键词高亮显示文本中的匹配部分
 */
const HighLightText: React.FC<IHighLightTextProps> = (props) => {
  const { text, keyword, className } = props;
  
  // 边界检查
  if (!keyword || !text) {
    return <>{text || null}</>;
  }
  
  /**
   * 转义正则表达式特殊字符
   * 防止用户输入的特殊字符导致正则表达式错误
   */
  const escapeRegExp = (str: string): string => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };
  
  try {
    const escapedKeyword = escapeRegExp(keyword);
    const parts = text.split(new RegExp(`(${escapedKeyword})`, 'gi'));
    
    return (
      <>
        {parts.map((part, index) => {
          const isMatch = part.toLowerCase() === keyword.toLowerCase();
          // 使用更好的 key 生成策略，避免相同内容时 key 冲突
          const key = `${index}-${part.substring(0, 10)}`;
          
          return isMatch ? (
            <span key={key} className={classNames(className, 'dbh-highlight-text')}>
              <b>{part}</b>
            </span>
          ) : (
            <React.Fragment key={key}>{part}</React.Fragment>
          );
        })}
      </>
    );
  } catch (error) {
    console.error('HighLightText rendering error:', error);
    return <>{text}</>;
  }
};

HighLightText.displayName = 'HighLightText';

export default HighLightText;